import { render, staticRenderFns } from "./accessible-dialog.vue?vue&type=template&id=2358da6a"
import script from "./accessible-dialog.vue?vue&type=script&lang=js"
export * from "./accessible-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports